// Storage for the shared app-wide password gate (see backend/middleware/
// appPassword.js) — same localStorage-not-React-state reasoning as
// actingUserStorage.js: the axios interceptor needs to read this
// synchronously on every request without being wired through the tree.
const STORAGE_KEY = 'optim_app_password';

export function getAppPassword() {
  return window.localStorage.getItem(STORAGE_KEY);
}

export function setAppPassword(password) {
  if (!password) {
    window.localStorage.removeItem(STORAGE_KEY);
  } else {
    window.localStorage.setItem(STORAGE_KEY, password);
  }
}
